export const brochureApplyAction= (data) => { 
    return {
       type: data.type,
       data: data.data
    }
 }